import { walletTermsQueryOptions } from '@src/queryOptions/terms'
import { cardProgramQueryOptions } from '@src/queryOptions/users'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/walletCreationOverview')({
  loader: async ({ context: { queryClient, store } }) => {
    const isEssential = store.getState().onboarding.essentialFlow
    return Promise.all([
      queryClient.ensureQueryData(
        walletTermsQueryOptions({ isPayCardAccount: isEssential })
      ),
      queryClient.ensureQueryData(cardProgramQueryOptions),
    ])
  },
})
